import { render, staticRenderFns } from "./topCustomers.vue?vue&type=template&id=0bfd196b&scoped=true"
import script from "./topCustomers.vue?vue&type=script&lang=js"
export * from "./topCustomers.vue?vue&type=script&lang=js"
import style0 from "./topCustomers.vue?vue&type=style&index=0&id=0bfd196b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd196b",
  null
  
)

export default component.exports